module.exports = __webpack_public_path__ + "asset/img/our-banner.b80091a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/our-banner.png
// module id = ESgy
// module chunks = 1